import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
  Button,
  Chip,
  Divider,
  makeStyles,
  Typography,
} from '@material-ui/core';
import {useState} from 'react';
import {ExpandMore} from '@material-ui/icons';
import {format} from 'date-fns';
import {FormattedMessage, useIntl} from 'react-intl';
import messages from '@super-template/messages';
import getTranslated from '@super-template/core/src/locale/getTranslated';
import useLocale from '@super-template/core/src/locale/useLocale';
import {expiring} from "./DesktopTable";
import {generatePath, useHistory} from "react-router-dom";
import {path as info} from "../../info";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(1),
    },
  },
  summary: {
    flexDirection: 'column',
  },
  details: {
    display: 'block',
  },
  columnLabel: {
    fontSize: theme.typography.caption.fontSize,
    display: 'block',
    lineHeight: '1em',
    fontFamily: theme.typography.bold,
    marginTop: '5px',
    '&::after': {
      content: '":"',
      marginRight: '5px',
    },
  },
  chip: {
    width: 'fit-content',
    marginTop: '5px',
  },
  btnLink: {
    color: 'white!important',
    textDecoration: 'none!important',
    whiteSpace: 'nowrap',
  },
  actions: {
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    marginTop: -theme.spacing(1),
    '& > *': {
      marginTop: theme.spacing(1),
    },
  },
}));
const Label = ({className, children}) => (
  <Typography component="span" className={className}>
    {children}
  </Typography>
);
const Primary = ({isHolidayOrganization, ...props}) => (
  <Chip
    {...props}
    size={'small'}
    color={'secondary'}
    label={<FormattedMessage {...isHolidayOrganization ? messages.primary_wish : messages.primary_course} />}
  />
);

export default function ({primary, summary, showPartner, array, wishes, selectPrimary, actionRemove, organization, isHolidayOrganization}) {
  const intl = useIntl();
  const classes = useStyles();
  const history = useHistory();
  const [expanded, setExpanded] = useState(false);
  const [locale] = useLocale();
  const handleChange = (panel) => (event, isExpanded) => setExpanded(isExpanded ? panel : false);

  return (
    <div className={classes.wrapper} id={"holidayAccordion"}>
      {array.map((row) =>
        <Accordion key={row.id} expanded={expanded === row.id} onChange={handleChange(row.id)}>
          <AccordionSummary
            id={'holiday_' + row.id + '_header'} className={classes.accordionSummary} expandIcon={<ExpandMore/>}
            aria-label={intl.formatMessage(messages.expand)} aria-controls={'holiday_' + row.id + '_container'}>
            <div className={'holiday_' + row.id + '_container'}>
              {showPartner && row.partnerOrganization?.name &&
                <Typography gutterBottom>
                  <Label className={classes.columnLabel}><FormattedMessage {...messages.partner} /></Label>
                  {row.partnerOrganization?.www ?
                    <a target={'_blank'} rel="noreferrer" href={row.partnerOrganization.www}>
                      {row.partnerOrganization.name}
                    </a> : row.partnerOrganization?.name}
                </Typography>}
              <Typography gutterBottom>
                <Label className={classes.columnLabel}><FormattedMessage {...messages.date} /></Label>
                {format(new Date(row.startDate), 'dd.MM.yyyy')}{' - '}{format(new Date(row.endDate), 'dd.MM.yyyy')}
              </Typography>
              <Typography gutterBottom>
                <Label className={classes.columnLabel}><FormattedMessage {...messages.theme} /></Label>
                {getTranslated(row.themeName, locale)}
              </Typography>
              <Typography>
                <Label className={classes.columnLabel}><FormattedMessage {...messages.target} /></Label>
                {row.resortOrganization.name}
              </Typography>
              {expanded !== row.id && primary && row.id === primary.id &&
                <Primary className={classes.chip} isHolidayOrganization={isHolidayOrganization}/>}
            </div>
          </AccordionSummary>
          <AccordionDetails className={classes.details}>
            <Typography gutterBottom className={expiring(row.applicationEndDate) ? 'warn' : ''}>
              <Label className={classes.columnLabel}><FormattedMessage {...messages.search_end_date} /></Label>
              {format(new Date(row.applicationEndDate), 'dd.MM.yyyy')}
            </Typography>
          </AccordionDetails>
          <Divider/>
          {!summary &&
            <AccordionActions className={classes.actions}>
              {primary && row.id === primary.id ?
                <Primary className={classes.chip} style={{marginRight: 'auto'}}
                         isHolidayOrganization={isHolidayOrganization}/> : wishes &&
                <Button size="small" color="primary" variant="outlined"
                        onClick={() => selectPrimary({target: {value: row.id}})} value={row.id}>
                  <FormattedMessage {...messages.mark_primary} />
                </Button>}
              {primary &&
                <Button style={{whiteSpace: 'nowrap'}} variant={'outlined'} size={'small'} color={'primary'}
                        onClick={() => actionRemove(row)}>
                  <FormattedMessage {...messages.remove_wish} />
                </Button>}
              {!wishes &&
                <Button className={classes.btnLink} variant={'contained'} size={'small'} color={'primary'}
                        onClick={() => history.push(generatePath(info, {organization, id: row.id}))}>
                  <FormattedMessage {...messages.open_holiday} />
                </Button>}
            </AccordionActions>}
        </Accordion>)}
    </div>
  );
}
